import FlashcardsAPI from "@/services/api/flashcards"
import { useMutation, useQueryClient } from "@tanstack/react-query"

const useUpdateDeckSet = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationKey: ["update-deck-set"],
    mutationFn: FlashcardsAPI.updateDeckSet,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-flashcards"] })
    },
  })
  return mutation
}

export default useUpdateDeckSet
